import { NavLink } from 'react-router-dom';
import { cn } from '@/lib/utils';
import type { NavSection } from './sidebar-nav-config';

export function SidebarNav({ sections }: { sections: NavSection[] }) {
  return (
    <nav className="flex flex-col gap-6 px-3 py-2">
      {sections.map((section, idx) => (
        <div key={section.heading ?? `section-${idx}`} className="flex flex-col gap-1">
          {section.heading && (
            <div className="px-3 pb-1 text-[11px] font-semibold tracking-wider text-sidebar-foreground">
              {section.heading}
            </div>
          )}
          {section.items.map((item) => {
            const Icon = item.icon;
            return (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                onClick={item.onSelect}
                className={({ isActive }) =>
                  cn(
                    'flex items-center gap-3 rounded-md px-3 py-2 text-sm font-normal text-sidebar-foreground transition-colors',
                    isActive ? 'bg-sidebar-accent text-primary [&>svg]:fill-primary' : 'hover:bg-sidebar-accent',
                  )
                }
              >
                <Icon className="h-4 w-4 fill-base-muted" />
                <span>{item.label}</span>
              </NavLink>
            );
          })}
        </div>
      ))}
    </nav>
  );
}
